import { startWorkflowAttempt } from '@/shared/libs';
import type { InviteEntryPoint, InviteSegment } from './types';

export const RENTER_INVITE_WORKFLOW = 'renter_invite';

// An explicit allowlist: the invite form holds renter emails, addresses and rent amounts, none of
// which may reach RUM.
export type InviteSubmitRumContext = {
  flowId: string | null;
  entryPoint: InviteEntryPoint | null;
  inviteSegment: InviteSegment;
  attemptNumber: number;
  applicantCount: number;
};

export const startInviteSubmitAttempt = ({
  flowId,
  entryPoint,
  inviteSegment,
  attemptNumber,
  applicantCount,
}: InviteSubmitRumContext) =>
  startWorkflowAttempt(RENTER_INVITE_WORKFLOW, 'submit', {
    flow_id: flowId ?? undefined,
    entry_point: entryPoint ?? 'unknown',
    invite_segment: inviteSegment,
    attempt_number: attemptNumber,
    applicant_count: applicantCount,
  });
